/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSegmentBudovy extends GContentBase<SeznamAdmSegmentBudovyObj> {
        private seznamObj: SeznamAdmSegmentBudovyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSegmentBudovyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSegmentBudovyNew",
                contentCaption: "jres:33001061",  //RC 33001061 : Segmenty budov
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ico} - {budova_kod} - {segment_kod}"
                },
                gridSettings: {
                    columnOrder: this.seznamObj.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSegmentBudovyObj extends GAdmSeznamBase {
        private ico: string;
        private budova_kod: string;

        getColumnOrder(): string {
            let columnOrder = "";
            if (!(this.ico && this.budova_kod))
                columnOrder += "ico,budova_kod,budova_kod_txt,"
            columnOrder += "segment_naz,patro,poznamka,segment_druh_txt,kod_vyu_txt,plocha,dat_zmena,zmenu_prov_txt"
            return columnOrder;
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmSegmentBudovy", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmSegmentBudovy",
                newRecord: isNew,
                ico: isNew == true ? this.ico : data.ico,
                budova_kod: isNew == true ? this.budova_kod : data.budova_kod,
                segment_kod: isNew == true ? null : data.segment_kod
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33001055").addField("gselectbox", Gordic.Prefabs.Select.ginsbud(), {
                name: "budova",
                model: "model.ico=value.ico;model.budova_kod=value.budova_kod",
                dropdown: true,
                disabled: this.ico && this.budova_kod ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ico && this.budova_kod) {
                hardFilter["ico"] = this.ico;
                hardFilter["budova_kod"] = this.budova_kod;
            }
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ico && this.budova_kod) {
                data["ico"] = this.ico;
                data["budova_kod"] = this.budova_kod;
            }
        }

        applydata(filterData: any) {
            this.cnt.beginOperation();
            this.cnt.isl.AdmSegmentBudovy.list({
                filters: filterData
            }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            }).always(() => { this.cnt.endOperation() });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ico}#${data.budova_kod}#${data.segment_kod}#`,
                nazev: data["segment_naz"]
            }
        }
    }
}